var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Form from '../form';
var ContactForm = /** @class */ (function (_super) {
    __extends(ContactForm, _super);
    function ContactForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { done: false };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            var data = new FormData(event.target);
            var obj = {};
            data['keys']().slice().filter(function (x) { return x; }).forEach(function (key) {
                obj[key] = data.get(key);
            });
            fetch(_this.props.post, {
                method: 'POST',
                body: JSON.stringify({ data: obj })
            }).then(function () {
                _this.setState({ done: true });
            });
        };
        return _this;
    }
    ContactForm.prototype.render = function () {
        var children = this.props.children;
        var done = this.state.done;
        if (done) {
            return React.createElement("span", null, "Anfrage wurde abgeschickt.");
        }
        return (React.createElement(Form, { onSubmit: this.handleSubmit },
            React.createElement("p", null, children),
            React.createElement("fieldset", null,
                React.createElement("label", { htmlFor: "email" }, "E-Mail"),
                React.createElement("input", { type: "email", name: "email" })),
            React.createElement("fieldset", null,
                React.createElement("label", { htmlFor: "name" }, "Name"),
                React.createElement("input", { type: "text", name: "name" })),
            React.createElement("fieldset", null,
                React.createElement("label", { htmlFor: "text" }, "Text"),
                React.createElement("textarea", { name: "message", rows: 4 })),
            React.createElement("button", { type: "submit" }, "Absenden")));
    };
    return ContactForm;
}(React.Component));
export default ContactForm;
//# sourceMappingURL=index.js.map